import CheckoutSuccessMain from './CheckoutSuccessMain';

export default CheckoutSuccessMain;
